export function installerReducer(state = null,{
    type,
    payload
}){
    switch(type){
        case "GET_INSTALLERS":
            return payload;
        case "UPDATE_INSTALLER":
            state[payload.id].other = payload.data
            return state;
        default:
            return state;
    }
}